import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filteredHistory: [],
    setSelectedSymbol: null,
    selectedTabType:'Trades'
};

const historySlice = createSlice({
    name: 'history',
    initialState,
    reducers: {
        setFilteredHistory: (state, action) => {
            state.filteredHistory = action.payload;
        },
        clearFilteredHistory: (state) => {
            state.filteredHistory = [];
        },
        setSelectedSymbol: (state, action) => {
            state.setSelectedSymbol = action.payload;
        },
        setSelectedTabType: (state,action) =>{
            state.selectedTabType = action.payload
        }
    },
});

export const { setFilteredHistory, clearFilteredHistory, setSelectedSymbol,setSelectedTabType } = historySlice.actions;
export default historySlice.reducer;
